import React from "react";

interface TranscriptViewProps {
  value: string;
  onChange: (value: string) => void;
  readOnly?: boolean;
}

export const TranscriptView: React.FC<TranscriptViewProps> = ({
  value,
  onChange,
  readOnly = false,
}) => {

  return (
    <div className="space-y-4">
      <div>
        <h3 className="text-lg font-semibold text-[#1D1D1F]">Transcript</h3>
        <p className="text-sm text-[#86868B] mt-1">
          Raw transcript from the audio recording
        </p>
      </div>

      <div className="relative">
        <textarea
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="w-full h-[500px] p-4 rounded-lg border border-[#E5E5EA] focus:border-[#007AFF] focus:ring-1 focus:ring-[#007AFF] outline-none transition-all duration-200 font-mono text-sm resize-none"
          placeholder="No transcript available..."
          readOnly={readOnly}
        />
      </div>
    </div>
  );
};
